export const DTUserSession = (userIdentification) => {
  try {
    window.dtrum.identifyUser(userIdentification);
  } catch (error) {}
};
